<template>
  <div>
    <div

      class="navbar_wrap hidden-xs-only none_992"
      :class="[
        { scrolled: isScrolled },
        { blue: computedIsBlue },
        { 'no-border-shadow': $route.path === '/home' },
      ]"
    >
      <div class="navbar_container">
        <div
          class="navbar_left"

        >
          <img
            v-if="
              isScrolled ||
              $route.path === '/about_us' ||
              $route.path === '/news_detail' ||
              currentSource === 'product_lie_11' ||
              currentSource === 'product_lie_12'
            "
                      @click="
            setActiveNav('home');
            $router.push({ path: '/home' });
          "
            src="@/assets/home/logo_2.png"
            class="logoImg"
          />
          <img v-else src="@/assets/home/logo_1.png" class="logoImg"
             @click="
            setActiveNav('home');
            $router.push({ path: '/home' });
          " />
          <!-- <span class="til" :class="{ scrolled: isScrolled }">华软股份</span> -->
        </div>
        <div class="navbar_center" @mouseleave="handleNavLeave">
          <ul class="nav_links">
            <li
              class="nav-link-item"
              :class="{
                black: $route.path === '/about_us' || isScrolled,
                bold: $route.path === '/home',
              }"
              @mouseenter="activeDropdown = null"
              @click="
                setActiveNav('home');
                $router.push({ path: '/home' });
              "
              style="white-space: nowrap"
            >
              首页
            </li>
            <li
              class="nav-link-item"
              :class="{ 
                black: $route.path === '/about_us' || isScrolled,
                bold: $route.path === '/product_lie' || activeDropdown === 'product'
              }"
              @mouseenter="showDropdown('product')"
              
              @click="setActiveNav('product')"
            >
              <span
                style="white-space: nowrap"
                >产品系列</span
              >
              <transition name="fade-slide">
                <div
                  v-if="activeDropdown === 'product'"
                  class="dropdown"
                  @mouseenter="showDropdown('product')"
                 
                  style="z-index: 1000; padding-top: 10px; padding-bottom: 40px;"
                >
                <div
                  class="dropdown_column"
                  v-for="(column, columnIndex) in dropdownColumns"
                  :key="columnIndex"
                  :style="{ marginRight: columnIndex === dropdownColumns.length - 1 ? '0' : '60px' }"
                >
                  <h4>{{ column.title }}</h4>
                  <!-- :style="item.text === '无人装备指挥车' ? { marginLeft: '45px' } : (item.text === '移动航空站' ? { marginLeft: '45px' } : {})" -->
                  <div>
                    <ul style="gap: 16px;margin-bottom: 16px;">
                      <li
                        v-for="(item, itemIndex) in column.items.slice(0, 4)"
                        :key="itemIndex"
                        @click="
                          navigateTo(item.route, item.text);
                          setActiveNav('product');
                        "
                        :style="{
                          fontWeight:
                            $route.query.source == item.route ? 'bold' : '',
                        }"
                      >
                        <img
                          :src="item.img"
                          class="dropdown_img"
                          :alt="item.alt"
                        />
                        {{ item.text }}
                        <span v-if="item.isHot" class="hot">HOT</span>
                        <span v-if="item.isNew" class="hot">NEW</span>
                      </li>
                    </ul>
                    <ul style="gap: 16px">
                      <li
                        v-for="(item, itemIndex) in column.items.slice(4, 8)"
                        :key="itemIndex"
                        @click="
                          navigateTo(item.route, item.text);
                          setActiveNav('product');
                        "
                        :style="{
                          display: item.text == '海空协同无人船（艇）' ? 'block' : 'inline-flex',
                          fontWeight:
                            $route.query.source == item.route ? 'bold' : '',
                          height: `${item.text == '海空协同无人船（艇）' ? '0px' : '40px'}`
                        }"
                      >
                        <h4 v-if="item.text == '海空协同无人船（艇）'" style="margin-bottom: 2px;pointer-events: none; ">
                          海空协同无人船（艇）
                        </h4>
                        <div style="display: flex;align-items: center;">
                          <img
                            :src="item.img"
                            class="dropdown_img"
                            :alt="item.alt"
                          />
                          {{ item.text }}
                          <span v-if="item.isHot" class="hot">HOT</span>
                          <span v-if="item.isNew" class="hot">NEW</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              </transition>
            </li>
            <li
              class="nav-link-item"
              :class="{ 
                black: $route.path === '/about_us' || isScrolled,
                bold: $route.path === '/industry_application' || activeDropdown === 'industry'
              }"
              @mouseenter="showDropdown('industry')"
              
              @click="setActiveNav('industry')"
              style="white-space: nowrap"
            >
              <span
                >行业应用</span
              >
              <transition name="fade-slide">
                <div
                  v-if="activeDropdown === 'industry'"
                  class="dropdownYing industry_dropdown"
                  @mouseenter="showDropdown('industry')"
      
                  style="z-index: 1000; padding-top: 10px; padding-bottom: 20px;"
                >
                <div
                  class="dropdown_column"
                  v-for="(column, columnIndex) in industryColumns"
                  :key="columnIndex"
                >
                  <h4>{{ column.title }}</h4>
                  <ul>
                    <li
                      v-for="(item, itemIndex) in column.items"
                      @click="naviToIns(item.route, item.text)"
                      :style="{
                        fontWeight:
                          $route.query.source == item.route ? 'bold' : '',
                      }"
                      :key="itemIndex"
                    >
                      {{ item.text }}
                    </li>
                  </ul>
                </div>
              </div>
              </transition>
            </li>
            <li
              class="nav-link-item"
              :class="{ 
                black: $route.path === '/about_us' || isScrolled,
                bold: ($route.path === '/all_user_cases' || $route.path === '/user_case_detail') || activeDropdown === 'userCase'
              }"
              style="white-space: nowrap"
              @mouseenter="showDropdown('userCase')"
 
            >
              <span
                >用户案例</span
              >
              <transition name="fade-slide">
                <div
                  v-if="activeDropdown === 'userCase'"
                  class="dropdownCase user_case_dropdown"
                  @mouseenter="showDropdown('userCase')"
     
                  style="z-index: 1000; padding-top: 40px; padding-bottom: 40px;"
                >
                <div
                  class="user_case_item"
                  v-for="(item, index) in userCases"
                  @click="naviUserTo('all_user_cases', item.id, item.subtitle)"
                  :key="index"
                  :style="{ backgroundImage: `url(${item.background})` }"
                >
                  <div class="user_case_item-box">
                    <div class="user_case_content">
                      <!-- <h4>{{ item.title }} </h4> -->
                      <p style="font-weight: 600">{{ item.subtitle }}</p>
                    </div>
                    <img
                      src="@/assets/home/arrow.png"
                      class="arrow_icon"
                      alt="arrow"
                    />
                  </div>
                </div>
              </div>
              </transition>
            </li>
            <li
              class="nav-link-item"
              :class="{ black: $route.path === '/about_us' || isScrolled }"
              style="white-space: nowrap"
              @click="navigateToNews"
              @mouseenter="activeDropdown = null"
            >
              <span
                :class="{
                  bold:
                    $route.path === '/news_center' ||
                    $route.path === '/news_detail',
                }"
                >新闻中心</span
              >
            </li>
            <li
              class="nav-link-item"
              :class="{ black: $route.path === '/about_us' || isScrolled }"
              @click="navigateToAboutUs"
              @mouseenter="activeDropdown = null"
              style="white-space: nowrap"
            >
              <span :class="{ bold: $route.path === '/about_us' }"
                >关于我们</span
              >
            </li>
          </ul>
        </div>
        <div class="navbar_right">
          <img
            :src="
              isScrolled ||
              $route.path === '/about_us' ||
              $route.path === '/news_detail' ||
              currentSource === 'product_lie_11' ||
              currentSource === 'product_lie_12'
                ? 'https://hr2.chnsoft.com.cn/img/phone.png'
                : 'https://hr2.chnsoft.com.cn/img/phoneWhite.png'
            "
            alt="电话"
            class="phoneImg"
          />
          <span
            class="phone_number"
            :class="{
              scrolled:
                isScrolled ||
                $route.path === '/about_us' ||
                $route.path === '/news_detail' ||
                currentSource === 'product_lie_11' ||
                currentSource === 'product_lie_12',
            }"
            >400-608-3777</span
          >
          <button
            class="consult_btn"
            :class="{
              scrolled:
                isScrolled ||
                $route.path === '/about_us' ||
                $route.path === '/news_detail' ||
                currentSource === 'product_lie_11' ||
                currentSource === 'product_lie_12',
            }"
            @click="showConsultDialog = true"
          >
            立即咨询
          </button>
        </div>
      </div>
    </div>
    <ConsultDialog
      v-if="showConsultDialog"
      @close="showConsultDialog = false"
      :visible="showConsultDialog"
      @submit="handleConsultSubmit"
    >
    </ConsultDialog>
    <el-dialog
      :visible.sync="dialogVisible"
      width="500px"
      class="consult-dialog"
    >
      <div class="dialog-content">
        <div class="icon"></div>
        <p>信息已提交，请耐心等待...</p>
        <el-button type="primary" @click="dialogVisible = false"
          >知道了</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ConsultDialog from "./ConsultDialog.vue";
export default {
  components: {
    ConsultDialog,
  },
  props: {
    isBlue: {
      type: String,
      default: "false",
    },
  },
  data() {
    return {
      isScrolled: false,
      activeDropdown: null, // Tracks the currently active dropdown
      showConsultDialog: false,
      currentSource: "",
      currNavTxt: "",
      hideTimer: null, // 用于延迟隐藏下拉菜单的定时器
      userCases: [
        // { id: 1, title: "Power", subtitle: "电力", background: require("@/assets/home/userCaseNav1.png") },
        // { id: 3, title: "Public safety", subtitle: "公共安全", background: require("@/assets/home/userCaseNav2.png") },
        // { id: 2, title: "Energy", subtitle: "能源", background: require("@/assets/home/userCaseNav3.png") },
        // { id: 4, title: "Other", subtitle: "其他", background: require("@/assets/home/userCaseNav4.png") },
        {
          id: 1,
          title: "Low economy",
          subtitle: "低空经济",
          background: require("@/assets/home/userCaseNav1.png"),
        },
        {
          id: 2,
          title: "Power grid",
          subtitle: "电网",
          background: require("@/assets/home/userCaseNav2.png"),
        },
        {
          id: 3,
          title: "New energy",
          subtitle: "新能源",
          background: require("@/assets/home/userCaseNav3.png"),
        },
        {
          id: 4,
          title: "Energy",
          subtitle: "能源",
          background: require("@/assets/home/userCaseNav4.png"),
        },
        {
          id: 5,
          title: "Rail Transit",
          subtitle: "轨道交通",
          background: require("@/assets/home/userCaseNav5.png"),
        },
        {
          id: 6,
          title: "Other",
          subtitle: "其他",
          background: require("@/assets/home/userCaseNav6.png"),
        },
      ],
      dialogVisible: false,
      dropdownColumns: [
        {
          title: "地空协同智能航空站（自动机场）",
          items: [
            {
              img: "https://hr2.chnsoft.com.cn/img/D51.png",
              alt: "集群式换电航站",
              text: "集群式换电航站",
              isHot: true,
              route: "product_lie_1",
            },
            {
              img: require("@/assets/home/V400Icon.png"),
              alt: "换电式自动机场",
              text: "换电式自动机场",
              isHot: false,
              route: "product_lie_2",
            },
            {
              img: require("@/assets/home/C350Icon.png"),
              alt: "充电式自动机场",
              text: "充电式自动机场",
              isHot: false,
              route: "product_lie_3",
            },
            {
              img: require("@/assets/home/VF7.png"),
              alt: "垂起固定翼机场",
              text: "垂起固定翼机场",
              isHot: false,
              route: "product_lie_4",
            },
            {
              img: require("@/assets/home/大载重机场2.png"),
              alt: "大载重自动机场",
              text: "大载重自动机场",
              isHot: false,
              route: "product_lie_5",
            },
            {
              img: "https://hr2.chnsoft.com.cn/img/空地一体母站.png",
              alt: "空地一体母站",
              text: "空地一体母站",
              isNew: true,
              route: "product_lie_5_1",
            },
            {
              img: 'https://hr2.chnsoft.com.cn/img/移动航空站.png',
              alt: "移动航空站",
              text: "移动航空站",
              isHot: true,
              route: "product_lie_6",
            },
            {
              img: require("@/assets/home/应急指挥车.png"),
              alt: "无人装备指挥车",
              text: "无人装备指挥车",
              isHot: false,
              route: "product_lie_7",
            },
          ],
        },
        {
          title: "陆空协同无人车（机器人）",
          items: [
            {
              img: require("@/assets/home/压缩空气泡沫智能消防车@1x.png"),
              alt: "陆空协同无人消防车",
              text: "陆空协同无人消防车",
              isHot: false,
              route: "product_lie_8",
            },
            {
              img: require("@/assets/home/应急处置机器人.png"),
              alt: "陆空协同应急处置机器人",
              text: "陆空协同应急处置机器人",
              isHot: false,
              route: "product_lie_9",
            },
            {
              img: require("@/assets/home/智能巡视机器人.png"),
              alt: "陆空协同智能巡视机器人",
              text: "陆空协同智能巡视机器人",
              isHot: false,
              route: "product_lie_8_1",
            },
            {
              img: require("@/assets/home/室内应急处置机器人.png"),
              alt: "室内应急处置机器人",
              text: "室内应急处置机器人",
              isHot: false,
              route: "product_lie_8_2",
            },
            // 已将海空协同无人船（艇）移到此处
            {
              img: require("@/assets/home/水上智能航空站.png"),
              alt: "海空协同无人船（艇）",
              text: "海空协同无人船（艇）",
              isBoat: true,
              isHot: false,
              route: "product_lie_10",
            },
          ],
        },
        // {
        //   title: "海空协同无人船（艇）",
        //   items: [
        //     {
        //       img: require("@/assets/home/水上智能航空站.png"),
        //       alt: "海空协同无人船（艇）",
        //       text: "海空协同无人船（艇）",
        //       isBoat: true,
        //       isHot: false,
        //       route: "product_lie_10",
        //     },
        //   ],
        // },
        {
          title: "软件系统",
          items: [
            {
              img: require("@/assets/home/ruanJian1.png"),
              alt: "智能全域巡视系统",
              text: "智能全域巡视系统",
              isHot: false,
              route: "product_lie_11",
            },
            {
              img: 'https://hr2.chnsoft.com.cn/img/ruanJian2.png',
              alt: "全域电网巡检系统",
              text: "全域电网巡检系统",
              isHot: false,
              route: "product_lie_12",
            },
          ],
        },
        {
          title: "全国产化智能大、小脑（服务器）",
          items: [
            {
              img: require("@/assets/home/AMS400V112.png"),
              alt: "机载智能大脑",
              text: "机载智能大脑",
              isHot: false,
              route: "product_lie_13",
            },
            {
              img: require("@/assets/home/ZF3588.png"),
              alt: "车(船)载智能大(小)脑",
              text: "车(船)载智能大(小)脑",
              isHot: false,
              route: "product_lie_13_1",
            },
            {
              img: require("@/assets/home/ZF-C200 边缘计算终端.png"),
              alt: "边端算力服务器",
              text: "边端算力服务器",
              isHot: false,
              route: "product_lie_13_2",
            },
            {
              img: "https://hr2.chnsoft.com.cn/img/%E4%BA%91%E7%AB%AF%E7%AE%97%E5%8A%9B%E6%9C%8D%E5%8A%A1%E5%99%A8%402x.webp",
              alt: "云端算力服务器",
              text: "云端算力服务器",
              isHot: false,
              route: "product_lie_14",
            },
          ],
        },
        {
          title: "其他产品",
          items: [
            {
              img: "https://hr2.chnsoft.com.cn/img/xiliunew.png",
              alt: "系留供电装置",
              text: "系留供电装置",
              isHot: false,
              route: "product_lie_15",
            },
            {
              img: "https://hr2.chnsoft.com.cn/img/CGS-C03 集控飞行地面站.png",
              alt: "无人装备便携地面站",
              text: "无人装备便携地面站",
              isHot: false,
              route: "product_lie_16",
            },
            {
              img: "https://hr2.chnsoft.com.cn/img/CGS-100 集控飞行座舱.png",
              alt: "无人装备驾控台",
              text: "无人装备驾控台",
              isHot: false,
              route: "product_lie_17",
            },
          ],
        },
      ],
      industryColumns: [
        {
          title: "低空经济",
          items: [
            { text: "无人+公共安全", route: "industry_uav_safe" },
            { text: "无人+执法", route: "industry_safety_1" },
            { text: "无人+应急", route: "industry_safety_2" },
            { text: "无人+环保", route: "industry_other_4" },
            { text: "无人+森林", route: "industry_uav_forest" },
            { text: "无人+水利", route: "industry_uav_water" },
            { text: "无人+投送", route: "industry_uav_delivery" },
          ],
        },
        {
          title: "电网",
          items: [
            { text: "输电线路", route: "industry_power_1" },
            { text: "变电（换流）站", route: "industry_power_2" },
            { text: "配网", route: "industry_power_3" },
          ],
        },
        {
          title: "新能源",
          items: [
            { text: "光伏发电", route: "industry_energy_1" },
            { text: "风力发电", route: "industry_energy_2" },
            { text: "抽水蓄能", route: "industry_energy_3" },
          ],
        },
        {
          title: "能源",
          items: [
            { text: "石油", route: "industry_energy_4" },
            { text: "天然气", route: "industry_energy_5" },
            { text: "管网", route: "industry_guan_wang" },
            { text: "矿业", route: "industry_other_3" },
          ],
        },
        {
          title: "轨道交通",
          items: [
            { text: "公路", route: "industry_gong_lu" },
            { text: "铁路", route: "industry_tie_lu" },
            { text: "地铁", route: "industry_di_tie" },
          ],
        },
        {
          title: "其他",
          items: [
            { text: "边海防", route: "industry_other_2" },
            { text: "港口", route: "industry_other_5" },
            { text: "基础建设", route: "industry_other_6" },
            { text: "海洋", route: "industry_hai_yang" },
          ],
        },
      ],
      // industryColumns: [
      //   {
      //     title: "电力",
      //     items: [
      //       { text: "输电", route: "industry_power_1" },
      //       { text: "变电", route: "industry_power_2" },
      //       { text: "配电", route: "industry_power_3" },
      //       { text: "直流", route: "industry_power_4" },
      //     ],
      //   },
      //   {
      //     title: "能源",
      //     items: [
      //       { text: "光伏", route: "industry_energy_1" },
      //       { text: "风电", route: "industry_energy_2" },
      //       { text: "抽水蓄能", route: "industry_energy_3" },
      //       { text: "石油", route: "industry_energy_4" },
      //       { text: "天然气", route: "industry_energy_5" },
      //     ],
      //   },
      //   {
      //     title: "公共安全",
      //     items: [
      //       { text: "执法", route: "industry_safety_1" },
      //       { text: "应急", route: "industry_safety_2" },
      //     ],
      //   },
      //   {
      //     title: "其他",
      //     items: [
      //       { text: "轨道交通", route: "industry_other_1" },
      //       { text: "边海防", route: "industry_other_2" },
      //       { text: "矿业", route: "industry_other_3" },
      //       { text: "环保", route: "industry_other_4" },
      //       { text: "港口", route: "industry_other_5" },
      //       { text: "基础建设", route: "industry_other_6" },
      //     ],
      //   },
      // ],
    };
  },
  watch: {
    // 监听 URL 的变化
    "$route.fullPath": {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        this.currentSource = source;
      },
    },
  },
  computed: {
    computedIsBlue() {
      return (
        this.isBlue === "true" ||
        this.currentSource === "product_lie_11" ||
        this.currentSource === "product_lie_12"
      );
    },
    activeNav() {
      return localStorage.getItem("activeNav") || "";
    },
  },
  mounted() {
    // 根据路由判断

    if (this.$route.path === "/home") {
      this.isScrolled = true;
    } else {
      this.isScrolled = this.computedIsBlue && window.scrollY > 0;
    }

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled =
        this.$route.path === "/home" ? true : window.scrollY > 0;

      // 滚动时关闭立即咨询弹窗
      this.showConsultDialog = false;
    },
    showDropdown(type) {
      this.isScrolled = true;
      // 清除所有定时器，确保不会有冲突
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      // 立即设置活动下拉菜单
      this.activeDropdown = type;
    },
    hideDropdown(type) {
      // 清除之前的定时器
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      // 添加延迟，给用户时间移动鼠标到下拉菜单或其他菜单项
      this.hideTimer = setTimeout(() => {
        // 只有当当前活动的仍然是这个类型时才隐藏
        if (this.activeDropdown === type) {
          this.activeDropdown = null;
        }
      }, 800); // 增加延迟时间到800ms，给用户更多时间
    },
    handleNavLeave() {
      // 当鼠标离开整个导航区域时，清除所有下拉菜单
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      // 立即隐藏下拉菜单
      this.activeDropdown = null;
    },
    handleConsultSubmit() {
      this.showConsultDialog = false;
      this.dialogVisible = true;
    },
    navigateTo(route, text) {
      this.currNavTxt = text;
      this.$nextTick(() => {
        // 强制刷新视图，确保加粗
      });
      if (text) {
        localStorage.setItem("selectedText", text);
        if (text == "海空协同无人船（艇）") {
          localStorage.setItem("TeDianBgProName", "水上智能航空站");
        } else if (text == "陆空协同无人消防车") {
          localStorage.setItem("TeDianBgProName", "陆空协同无人消防车");
        } else if (text == "算力服务器") {
          localStorage.setItem("TeDianBgProName", "ZF-C200 边缘计算终端");
        } else if (text == "机载板卡") {
          localStorage.setItem("TeDianBgProName", "ZF-A400 算力板卡");
        } else if (text == "系留供电装置") {
          localStorage.setItem("TeDianBgProName", "系留供电装置");
        } else if (text == "无人装备便携地面站") {
          localStorage.setItem("TeDianBgProName", "无人装备便携地面站");
        } else if (text == "机载任务系统") {
          localStorage.setItem("TeDianBgProName", "AMS-400-V112 机载任务系统");
        } else if (text == "无人装备驾控台") {
          localStorage.setItem("TeDianBgProName", "无人装备驾控台");
        } else if (text == "智能全域巡视系统") {
          localStorage.setItem("TeDianBgProName", "智能全域巡视系统");
        } else if (text == "全域电网巡检系统") {
          localStorage.setItem("TeDianBgProName", "全域电网巡检系统");
        } else {
          localStorage.setItem("TeDianBgProName", text);
        }
      }
      if (route) {
        this.$router.push({ path: "/product_lie", query: { source: route } });
      }
      this.isScrolled = false;
      this.activeDropdown = null;
    },
    naviToIns(route, text) {
      this.currNavTxt = text;

      if (text) {
        localStorage.setItem("selectedText", text);
        localStorage.setItem("TeDianBgProName", text);
      }
      if (route) {
        this.$router.push({
          path: "/industry_application",
          query: { source: route },
        });
      }
      this.$nextTick(() => {
        // 强制刷新视图，确保加粗
      });
      localStorage.setItem("activeNav", "industry");
      this.hideDropdown("industry");
    },

    naviUserTo(route, id, text) {
      if (text) {
        localStorage.setItem("selectedText", text);
        localStorage.setItem("TeDianBgProName", text);
      }
      if (route) {
        this.$router.push({
          path: "/all_user_cases",
          query: { source: route, navUserCaseType: id },
        });
      }
      localStorage.setItem("activeNav", "userCase");
    },

    navigateToAboutUs() {
      this.$router.push({ path: "/about_us" });
      localStorage.setItem("activeNav", "about");
    },

    navigateToNews() {
      this.$router.push({ path: "/news_center" });
      localStorage.setItem("activeNav", "news");
    },

    handleMenuItemLeave() {
      // 鼠标移出时恢复滚动状态
      this.isScrolled =
        this.$route.path === "/home" ? true : window.scrollY > 0;
    },
    setActiveNav(nav) {
      localStorage.setItem("activeNav", nav);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar_wrap {
  width: 100%;
  height: 80px;
  line-height: 60px;
  align-items: center;
  position: fixed;
  padding: 0px 120px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  // transition: background-color 0.3s, border-bottom 0.3s;

  // 默认字体颜色
  color: white;
   max-width: 100%;
  margin: 0 auto;
  transform-origin: top center;
  // transform: scale(var(--pc-scale, 1));
  height: auto;
  display: block;
  &.blue {
    // isBlue为true时字体为黑色
    color: black;

    // 让子元素字体也为黑色
    .til,
    .nav_links li,
    .phone_number {
      color: black !important;
    }
  }

  &.scrolled {
    background-color: white;
    border-bottom: 1px solid #dcdcdc;
    // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

    // isBlue为true并且滚动时，背景为白色
    &.blue {
      background-color: white;
      border-bottom: 1px solid #dcdcdc;
      // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
  }

  // isBlue为true且未滚动时，无背景
  &.blue:not(.scrolled) {
    background-color: unset;
    border-bottom: unset;
    box-shadow: unset;
  }

  &.no-border-shadow {
    border-bottom: none !important;
    box-shadow: none !important;
  }
}

@media (max-width: 1440px) {
  .navbar_wrap {
    padding: 0px 80px;
  }
}

.navbar_container {
  display: flex;
  align-items: center;
  width: 100%;
  // padding: 10px 0px; 
  // gap: 80px;
}

.navbar_left {
  display: flex;
  align-items: center;
  margin-right: 60px;
  min-width: 140px;
  cursor: pointer;
  transition: all 0.5s;

  .logoImg {
    height: 40px;
    transition: all 0.5s;
  }

  .til {
    margin-left: 12px;
    font-size: 20px;
    font-weight: bold;
    color: white;
    transition: color 0.5s;

    &.scrolled {
      color: #003d7e;
    }
  }
}

.navbar_center {
  // width: 60%;

  ul.nav_links {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    .nav-link-item {
      // min-width: 64PX;
      padding: 10px 0;
    }

    li {
      // min-width: 65px;
      margin: 0 30px;
      font-size: 16px;
      color: white;
      cursor: pointer;
      // position: relative;
      transition: color 0.3s, font-weight 0.3s;

      &.bold {
        font-weight: bold;
      }

      &:hover {
        // color: #0f6bf6;

        .hover_underline {
          width: 100%;
        }
      }

      .hover_underline {
        position: absolute;
        bottom: -5px;
        left: 0;
        height: 2px;
        background-color: #4a4a4a;
        width: 0;
        transition: width 0.3s;
      }

      &.black {
        color: black;
      }

      .dropdown {
        position: absolute;
        top: 80px;
        left: 0;
        background: white;
        border-top: 1px solid rgba(30, 36, 42, 0.1);
        box-shadow: 0px 1px 0px 0px rgba(30, 36, 42, 0.1);
        display: flex;
        width: 100%;
        // padding: 10px 10% 40px;
        padding-top: 10px;
        padding-bottom: 40px;
        z-index: 1000;
        display: flex;
        justify-content: center;

        .dropdown_column {
          margin-right: 60px;
          font-weight: normal;

          h4 {
            font-size: 14px;
            margin-bottom: 20px;
            color: #1e242a;
            position: relative;
            border-bottom: 1px solid #1e242a1a;

            &::after {
              content: "";
              display: block;
              width: 200px;
              height: 0px;
              // background-color: #1E242A;
              opacity: 0.1;
              margin-top: 5px;
            }
          }

          ul {
            list-style: none;
            padding: 0;
            display: flex;
            flex-direction: column;

            li {
              height: 40px;
              color: #1e242a;
              display: inline-flex;
              align-items: center;
              // margin-bottom: 10px;
              white-space: nowrap;
              margin-right: 16px;
              margin-left: 0px;
              min-width: 100px;
              font-size: 14px;

              &:hover {
                font-weight: bold;
              }

              img {
                margin-right: 10px;
              }

              .dropdown_img {
                margin-right: 10px;
                max-width: 34px;
                max-height: 34px;
              }

              .hot {
                border: 1px solid red;
                color: red;
                font-size: 11px;
                padding: 2px 3px;
                border-radius: 3px;
                margin-left: 15px;
                height: 22px;
                line-height: 19px;
              }
            }
          }
        }

        @media (max-width: 1440px) {
          .dropdown_column {
            margin-right: 10px;
          }
        }

        @media (max-width: 1366px) {
          .dropdown_column {
            margin-right: 3px;
          }
        }

        &.user_case_dropdown {
          display: grid;
          grid-template-columns: repeat(6, 1fr); // 修改为一排6个
          gap: 50px;
          // padding: 20px;

          .user_case_item {
            position: relative;
            width: 240px;
            height: 160px;
            background: url("../../assets/home/userCase.png") no-repeat
              center/cover;
            border-radius: 10px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: left;
            transition: background 0.3s;

            // 新增：hover时隐藏h4
            &:hover .user_case_content h4 {
              display: none;
            }

            // 新增：hover时p移动到图片左侧并设置样式
            &:hover .user_case_content p {
              position: absolute;
              left: 20px;
              top: 50%;
              transform: translateY(-50%);
              font-size: 18px;
              font-weight: bold;
              line-height: normal;
              letter-spacing: 0px;
              color: #ffffff;
              margin: 0;
              z-index: 2;
            }

            @media (max-width: 1440px) {
              &:hover .user_case_content p {
                font-size: 16px;
              }
            }

            .user_case_content {
              position: relative;
              z-index: 2;
              color: white;
              width: 100%;
              h4 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 5px;
              }

              p {
                font-size: 14px;
                // 默认样式，hover时会被覆盖
              }
            }

            .arrow_icon {
              position: absolute;
              bottom: 10px;
              right: 10px;
              width: 32px;
              height: 32px;
              z-index: 2;
            }
          }
        }
      }

      @media (max-width: 1440px) {
        .dropdown {
          padding: 10px 3% 40px;
        }
      }

      @media (max-width: 1366px) {
        .dropdown {
          padding: 10px 0.8% 40px;
        }
      }

      // @media (max-width: 1440PX) {
      //   .dropdown {
      //     padding: 10px 7% 40px;
      //   }
      // }

      .dropdownYing {
        position: absolute;
        display: flex;
        justify-content: center;
        top: 80px;
        left: 0;
        background: white;
        border-top: 1px solid rgba(30, 36, 42, 0.1);
        box-shadow: 0px 1px 0px 0px rgba(30, 36, 42, 0.1);
        display: flex;
        width: 100%;
        // padding: 10px 1050px 10px 550px;
        z-index: 1000;

        gap: 30px;

        &.industry_dropdown {
          padding-bottom: 20px;

          .dropdown_column {
            font-weight: normal;
            margin-right: 20px;

            h4 {
              font-size: 14px;
              margin-bottom: 12px;
              color: #1e242a;
              font-weight: bold;
              position: relative;

              &::after {
                content: "";
                display: block;
                width: 140px;
                height: 1px;
                background-color: #1e242a;
                opacity: 0.1;
                margin-top: 5px;
              }
            }

            ul {
              list-style: none;
              padding: 0;

              li {
                font-size: 14px;
                color: #1e242a;
                margin: 0px;
                height: 46px;
                line-height: 46px;

                &:hover {
                  font-weight: bold;
                }
              }
            }
          }
        }

        &.user_case_dropdown {
          display: grid;
          grid-template-columns: repeat(6, 1fr); // 修改为一排6个
          gap: 50px;
          // padding: 20px;

          .user_case_item {
            position: relative;
            width: 240px;
            height: 160px;
            background: url("../../assets/home/userCase.png") no-repeat
              center/cover;
            border-radius: 10px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: left;
            transition: background 0.3s;

            // 新增：hover时隐藏h4
            &:hover .user_case_content h4 {
              display: none;
            }

            // 新增：hover时p移动到图片左侧并设置样式
            &:hover .user_case_content p {
              position: absolute;
              left: 20px;
              top: 50%;
              transform: translateY(-50%);
              font-size: 18px;
              font-weight: bold;
              line-height: normal;
              letter-spacing: 0px;
              color: #ffffff;
              margin: 0;
              z-index: 2;
            }

            @media (max-width: 1440px) {
              &:hover .user_case_content p {
                font-size: 16px;
              }
            }

            .user_case_content {
              position: relative;
              z-index: 2;
              color: white;
              width: 100%;

              h4 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 5px;
              }

              p {
                font-size: 14px;
                // 默认样式，hover时会被覆盖
              }
            }

            .arrow_icon {
              position: absolute;
              bottom: 10px;
              right: 10px;
              width: 32px;
              height: 32px;
              z-index: 2;
            }
          }
        }
      }

      .dropdownCase {
        position: absolute;
        top: 80px;
        left: 0;
        background: white;
        border-top: 1px solid rgba(30, 36, 42, 0.1);
        box-shadow: 0px 1px 0px 0px rgba(30, 36, 42, 0.1);
        // padding: 40px 310px 40px 310px;
        padding-bottom: 40px;
        padding-top: 40px;
        // display: flex;
        justify-content: center;
        z-index: 1000;
        width: 100%;

        &.industry_dropdown {
          .dropdown_column {
            margin-right: 20px;
            font-weight: normal;

            h4 {
              font-size: 14px;
              margin-bottom: 10px;
              color: #1e242a;
              font-weight: bold;
              position: relative;

              &::after {
                content: "";
                display: block;
                width: 200px;
                height: 1px;
                background-color: #1e242a;
                opacity: 0.1;
                margin-top: 5px;
              }
            }

            ul {
              list-style: none;
              padding: 0;

              li {
                font-size: 14px;
                color: #1e242a;
                margin-bottom: 10px;
              }
            }
          }
        }

        &.user_case_dropdown {
          display: flex;
          grid-template-columns: repeat(6, 1fr); // 修改为一排6个
          gap: 24px;
          // padding: 20px;

          .user_case_item {
            position: relative;
            width: 200px;
            height: 150px;
            background: url("../../assets/home/userCase.png") no-repeat
              center/cover;
            border-radius: 12px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: left;
            transition: all 0.25s;
            border: 10px solid #F8F9F9;
            .user_case_item-box{
              border-radius: 8px;
              width: 100%;
              height: 100%;
              overflow: hidden;
            }
            &:hover::after {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(30, 36, 42, 0.4);
              /* 浅灰色浮层 */
              border-radius: 10px;
              z-index: 1;
            }

            &:hover .arrow_icon {
              content: url("../../assets/home/arrGra.png");
            }

            &:hover .user_case_content {
              position: relative;
              z-index: 2;
              color: white;
              width: 100%;
              padding-right: 60px;
              padding-top: 30px;
              p{
                
                text-align: right;
              }
            }

            .user_case_content {
              position: relative;
              z-index: 2;
              color: white;
              width: 100%;
              padding-left: 24px;
              height:100%;
              line-height: 130px;
              background: rgba(30, 36, 42, 0.2);
              transition: all 0.25s;
              h4 {
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 5px;
                height: 25px;
              }

              p {
                width: 100px;
                font-size: 18px;
              }
            }

            .arrow_icon {
              position: absolute;
              bottom: 20px;
              right: 20px;
              width: 32px;
              height: 32px;
              z-index: 2;
            }
          }
        }
      }

      @media (max-width: 1440px) {
        .dropdownCase {
          padding: 40px;
        }
      }

      @media (max-width: 1366px) {
        .dropdownCase {
          padding: 40px 12px;
        }
      }
    }

    .scrolled li {
      color: black;
    }
  }
}

.navbar_right {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
  // margin-left: 8%;

  .phoneImg {
    height: 30px;
    margin-right: 10px;
  }

  .phone_number {
    font-size: 16px;
    color: white;
    // margin-right: 20px;
    transition: color 0.3s;
    min-width: 120px;

    &.scrolled {
      color: black;
    }
  }

  .consult_btn {
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: white;
    padding: 5px 15px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s;
    width: 160px;
    height: 40px;
    font-size: 14px;
    line-height: 20px;

    &.scrolled {
      background-color: #0f6bf6;
      color: white;
      border-color: #0f6bf6;
    }

    &:hover {
      background-color: white;
      color: #0f6bf6;
    }
  }
}

.consult-dialog {
  .dialog-content {
    text-align: center;
    width: 100%;
    height: 400px;
    text-align: center;
    padding: 20px;
    background-image: url("../../assets/home/clockBg.png");
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .icon {
      font-size: 50px;
      color: #0f6bf6;
      margin-bottom: 60px;
      background-image: url("../../assets/home/clock.png"); // 确保图片路径正确
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 140px;
      /* 修改宽度 */
      height: 140px;
      /* 修改高度 */
    }

    p {
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #1e242a;
      opacity: 1;
      margin-bottom: 30px;
    }

    .el-button {
      width: 160px;
      height: 40px;
      border-radius: 4px;
      background: #0f6bf6;
      margin: 0 auto;
    }
  }
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0 !important;
}

::v-deep .el-dialog__footer {
  padding: 10px !important;
}

::v-deep .el-input__inner {
  border: none;
}

.bold {
  font-weight: bold;
}

  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
  }

  .fade-slide-enter,
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .nav_links .nav-link-item:hover {
    font-weight: bold;
  }
</style>